import React from 'react';
import { View, Flex, Spinner, Text } from '@smarterservices/smarter-ui';
import { useExamSessionStore, getStore } from '../../stores/StoreContext';
import { useState, useEffect } from 'react';
import { formatDuration } from '../../helpers/utilities';
function NoVideo() {
  const ExamSessionStore = getStore('examSessionStore');

  const currentJourneyStepId = useExamSessionStore(
    (state) => state.journey.currentJourneyStepId
  );
  const [currentJourneyStep, setCurrentJourneyStep] = useState(null);
  const [elapsedTime, setElapsedTime] = useState(0);

  useEffect(() => {
    const currentStep = ExamSessionStore.getCurrentJourneyStep();
    setCurrentJourneyStep(currentStep);
  }, [currentJourneyStepId]);

  useEffect(() => {
    let intervalId;

    if (currentJourneyStep?.startTime) {
      // Calculate initial elapsed time
      const startTime = new Date(currentJourneyStep.startTime);
      const now = new Date();
      const initialElapsedSeconds = Math.floor((now - startTime) / 1000);
      setElapsedTime(initialElapsedSeconds);

      // Update elapsed time every second
      intervalId = setInterval(() => {
        setElapsedTime((prevTime) => prevTime + 1);
      }, 1000);
    }

    // Clean up interval on unmount
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [currentJourneyStep]);

  return (
    <View
      as="div"
      height="300px"
      display="flex"
      width="100%"
      alignItems="center"
      justifyContent="center"
      background="secondary"
      borderRadius="large"
      aria-busy="true"
      role="status"
      textAlign="center"
    >
      <Flex
        direction="column"
        width="100%"
        alignItems="center"
        justifyItems="center"
        gap="medium"
        withVisualDebug={false}
      >
        <Spinner
          renderTitle="Loading video tracks"
          size="medium"
          color="primary"
          margin="small"
        />
        <Text as="div" size="large" color="primary">
          Session not live or recorded
        </Text>
        <Text as="div" size="medium" color="primary">
          Current Status: {ExamSessionStore.sessionData.status}
        </Text>
      </Flex>
    </View>
  );
}

export default NoVideo;
